import React from 'react';
import { colors } from '../../../colors';

const Backstory = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '75%',
        marginTop: 150,
      }}
    >
      <Line isActive={false} />
      <Circle
        isActive={true}
        year={2020}
        title="Started with an idea"
        position="top"
      />
      <Line isActive={true} />
      <Circle
        isActive={true}
        year={2021}
        title="Banging my head"
        position="bottom"
      />
      <Line isActive={true} />
      <Circle isActive={true} year={2022} title="Pause" position="top" />
      <Line isActive={true} />
      <Circle
        isActive={true}
        year={2023}
        title="Improving the algorithm"
        position="bottom"
        titleOffset={-33}
      />
      <Line isActive={true} />
      <Circle isActive={true} year={2024} title="Fml" position="top" />
      <Line isActive={true} />
      <Circle
        isActive={true}
        year={2025}
        title="Going live"
        position="bottom"
      />
      <Line isActive={false} />
      <Circle
        isActive={false}
        year={2026}
        title="Profit improvements<br>Monetization"
        position="top"
      />
      <Line isActive={false} />
      <Circle
        isActive={false}
        year={2027}
        title="Profit improvements<br>Monetization"
        position="bottom"
        titleOffset={-33}
      />
      <Line isActive={false} />
    </div>
  );
};

const Line = ({ isActive }: { isActive: boolean }) => {
  return (
    <div
      style={{
        height: 2,
        flex: 1,
        // backgroundColor: isActive ? colors.white : colors.gray,
        backgroundColor: colors.white,
        opacity: isActive ? 1 : 0.3,
      }}
    ></div>
  );
};

const Circle = ({
  isActive,
  year,
  title,
  position,
  titleOffset,
}: {
  isActive: boolean;
  year: number;
  title: string;
  position: 'top' | 'bottom';
  titleOffset?: number;
}) => {
  return (
    <div
      style={{
        width: 18,
        height: 18,
        borderRadius: 36,
        borderWidth: 3,
        borderStyle: 'solid',
        // color: isActive ? colors.white : colors.gray,
        color: colors.white,
        opacity: isActive ? 1 : 0.3,
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          position: 'absolute',
          bottom: position === 'top' ? 30 : -40,
          // color: isActive ? colors.white : colors.gray,
          color: colors.white,
          fontSize: 22,
        }}
      >
        {year}
      </div>
      <div
        style={{
          position: 'absolute',
          bottom: (position === 'top' ? 60 : -70) + (titleOffset ?? 0),
          // color: isActive ? colors.white : colors.gray,
          color: colors.white,
          fontSize: 22,
          width: 200,
          textAlign: 'center',
        }}
        dangerouslySetInnerHTML={{ __html: title }}
      ></div>
    </div>
  );
};

export default Backstory;
